import MyAccountService from "../../services/MyAccountService";
import ServicesService from "../../services/ServicesService";


class AppConfig {
  constructor() {
    this.attrs = {};
  }

  async fetch() {
    const account = await MyAccountService.fetch();
    if (account.getOrganizationId()) {
      this.attrs.organizationId = account.getOrganizationId();
      const services = await ServicesService.getOrganizationStores({
        organizationId: account.getOrganizationId(),
      });
      console.log('services', services);
      
      if (services.length) {
        this.attrs.serviceId = services[0].id;
        this.attrs.storeName = services[0].name;
      }
    }
  }

  getServiceId() {
    return this.attrs.serviceId;
  }

  getStoreName() {
    return this.attrs.storeName;
  }

  getAccountId() { }

  getOrganizationId() {
    return this.attrs.organizationId;
  }

  setOrganizationId(organizationId) {
    this.attrs.organizationId = organizationId;
  }

  getAccount() { }

  isOwner() { }

  isStaff() {
    return this.attrs.isStaff;
  }
}

export default new AppConfig();
